import * as api from "./api";

export const sendOtp = (params) => {
  return api.post("/auth/send-otp", params);
};

export const verifyOtp = (params) => {
  return api.post("/auth/verify-otp", params);
};

export const logout = (params) => {
  return api.post("/auth/logout", params);
};
